
$(document).ready(function() {

  
  window.setTimeout(function(){
    $('.popup-container').addClass('active');
    window.setTimeout(function(){
       $('.popup-container').removeClass('active');
    }, 700000)
  }, 500)


  $('.popup-container .close').click(function(){
    $('.popup-container').removeClass('active');
  })
  
  $('.single-faq').click(function(){
    $(this).toggleClass('active');
  })  

 //collection slick slider 
  $('.slick-slider-collections').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]  
  });
});